import React, {useState} from 'react';
import {Link, NavLink, useNavigate} from 'react-router-dom';
import {useLocation} from 'react-router-dom';
import './index.scss';
import { useTranslation } from '../../hooks/useTranslation';
import Inspection from '../../SVG/Inspection';
import Corrective from '../../SVG/Corrective';
import Fuel from '../../SVG/Fuel';
import Log from '../../SVG/Log';
import Service from '../../SVG/Service';
import Equipment from '../../SVG/Equipment';
import Management from '../../SVG/Management';
import FacilityIcon from '../../SVG/Facility';
import EquipmentType from '../../SVG/EquipmentType';
import {useDispatch, useSelector} from 'react-redux';
import {setLoader} from '../../store/builder/reducer';
import {logoutUser} from '../../store/builder/loginSlice';
import Report from '../../SVG/Report';
import {setSidebar} from '../../store/builder/inspectionSlice';
import AgencyDropdown from '../AgencyDropdown';
import Settings from '../../SVG/Settings';
import LanguageIcon from '../../SVG/LanguageIcon';
import SideFBODropdown from '../SideFBODropdown';
import Monitor from '../../SVG/Monitor';
import CorporateIcon from '../../SVG/CorporateIcon';
import FBOManagementIcon from '../../SVG/FBOManagementIcon';
import FboGraphicsIcon from '../../SVG/FBOGraphicsIcon';
import SideCorporateDropdown from '../SideCorporateDropdown';
import ToolsIcon from '../../SVG/ToolsIcon';
import SideCustomInspectionsDropdown from '../SideCustomInspectionsDropdown/SideCustomInspectionsDropdown';
import FBOList from '../FBOList';
import UserPlaceHolder from '/assets/icons/user.svg';
import LogoutIcon from '/assets/icons/logout.svg';
import routes from '../../utils/routes';
import NoteIcon from '../../SVG/NoteIcon';

export default function Sidebar() {
  const { t } = useTranslation();
  const [dropdown, setDropdown] = useState(false);
  const dispatch = useDispatch();
  const sidebarStatus = useSelector(
    state => state?.rootReducer?.inspectionSlice?.sidebar,
  );
  const userInfo = useSelector(state => state?.rootReducer?.loginSlice?.user);
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <>
      <div className={`sidebar ${sidebarStatus ? 'active' : ''}`}>
        <div className='sidebar__top'>
          <div className='sidebar__status'>
            <img
              onClick={() => {
                navigate('/inspections');
              }}
              className='sidebar-logo'
              src='/assets/icons/Logo.svg'
              alt='logo'
            />
            <img
              className='sidebar__menu'
              src={
                sidebarStatus
                  ? '/assets/icons/menu-active.svg'
                  : '/assets/icons/menu.svg'
              }
              alt='menu'
              onClick={() => {
                dispatch(setSidebar(!sidebarStatus));
                localStorage.setItem('sidebar-status', !sidebarStatus);
              }}
            />
          </div>
          {(userInfo?.is_corporate || userInfo?.is_regional_corporate) && (
            <>
              <div className='sidebar__links-corporate'>
                <NavLink
                  className={`sidebar__link ${location.pathname === '/corporate-dashboard' ? 'active' : ''}`}
                  to='/corporate-dashboard'
                >
                  <Inspection
                    color={
                      location.pathname === '/corporate-dashboard'
                        ? '#FFFFFF'
                        : '#AEB3B7'
                    }
                  />
                  <p className='sidebar__link-name'>{t('sidebar.dashboard')}</p>
                </NavLink>
                <NavLink
                  className={`sidebar__link ${location.pathname === '/fbo-management' ? 'active' : ''}`}
                  to='/fbo-management'
                >
                  <FBOManagementIcon
                    color={
                      location.pathname === '/fbo-management'
                        ? '#FFFFFF'
                        : '#AEB3B7'
                    }
                  />
                  <p className='sidebar__link-name'>{t('sidebar.fboManagement')}</p>
                </NavLink>
                <SideCustomInspectionsDropdown
                  custom_inspections_disabled={
                    userInfo?.corporate?.custom_inspections_enabled === 0
                  }
                />

                {userInfo?.permissions?.includes('user_management') && (
                  <Link
                    className={`sidebar__link ${location.pathname === '/management' ? 'active' : ''}`}
                    to='/management'
                  >
                    <Management
                      color={
                        location.pathname === '/management'
                          ? '#FFFFFF'
                          : '#AEB3B7'
                      }
                    />
                    <p className='sidebar__link-name'>{t('sidebar.userManagement')}</p>
                  </Link>
                )}
              </div>
              <div className='sidebar__divider'></div>
            </>
          )}
          <div className='sidebar__agancy'>
            {
              userInfo?.role.name !== 'translator' &&
                <AgencyDropdown dropdown={dropdown} setDropdown={setDropdown} />

            }
          </div>

          <SidebarContent userInfo={userInfo} location={location} t={t} />
          
        </div>

        <UserProfile userInfo={userInfo} />
      </div>
      {(userInfo?.is_global ||
        userInfo?.is_corporate ||
        userInfo?.is_regional_corporate) &&
        dropdown && (
          <FBOList sidebarStatus={sidebarStatus} setDropdown={setDropdown} />
        )}
    </>
  );
}

const UserProfile = ({userInfo}) => {
  const { t } = useTranslation();
  const [profileStatus, setProfileStatus] = useState(false);
  const dispatch = useDispatch();

  const handleLogOut = () => {
    dispatch(setLoader(true));
    dispatch(logoutUser());
    dispatch(setLoader(false));
  };

  return (
    <>
      <div
        className='sidebar__user'
        onClick={() => setProfileStatus(!profileStatus)}
      >
        <img
          src={userInfo?.avatar || UserPlaceHolder}
          alt='profile'
          className='sidebar__user-photo'
        />
        <div className='sidebar__user-info'>
          <p className='sidebar__user-name'>{userInfo?.name}</p>
          <p className='sidebar__user-role'>{userInfo?.role?.name}</p>
        </div>
      </div>
      {profileStatus && profileWindow(userInfo, setProfileStatus, handleLogOut, t)}
    </>
  );
};

const profileWindow = (userInfo, setProfileStatus, handleLogOut, t) => {
  return (
    <div className='sidebar__profile'>
      <div className='sidebar__btns'>
        <Link
            className='sidebar__btn'
            to={'/profile'}
            onClick={() => setProfileStatus(false)}
          >
            <img src={UserPlaceHolder} alt='icon' />
            <span>Profile</span>
          </Link>
        {(userInfo?.is_corporate || userInfo?.is_regional_corporate) && (
          <Link
            className='sidebar__btn'
            to={'/corporate-settings'}
            onClick={() => setProfileStatus(false)}
          >
            <img src='/assets/icons/coin.svg' alt='icon' />
            <span>{t('sidebar.corporateSettings')}</span>
          </Link>
        )}
        {userInfo?.role?.name === 'admin' && (
          <Link
            className='sidebar__btn'
            to={'/fbo-settings'}
            onClick={() => setProfileStatus(false)}
          >
            {(((userInfo?.agency?.trial_status === 'equipment' ||
              userInfo?.agency?.trial_status === 'inspection') &&
              userInfo?.subscription === null) ||
              userInfo?.payment_data?.length === 0 ||
              Object.values(userInfo?.address).every(item => item === null)) &&
              userInfo?.agency?.is_settings_complete && (
                <div
                  style={{top: '9px', left: '1px'}}
                  className='red-dot'
                ></div>
              )}
            <img src='/assets/icons/codesandbox.svg' alt='icon' />
            <span>{t('sidebar.fboSettings')}</span>
          </Link>
        )}

        <div onClick={handleLogOut} className='sidebar__btn logout'>
          <img src={LogoutIcon} alt='icon' />
          <span>{t('sidebar.logOut')}</span>
        </div>
      </div>
    </div>
  );
};

const SidebarContent = ({ userInfo, location, t }) => { 
  
  if (userInfo?.role.name === 'translator' && userInfo?.permissions?.includes('locale_management')) {
    return (
      <div className='sidebar__links'>
                <NavLink
                  className={`sidebar__link ${location.pathname === routes.private.languageManagement ? 'active' : ''}`}
                  to={routes.private.languageManagement}
                >
                  <LanguageIcon />
                  <p className='sidebar__link-name'>{t('sidebar.languageManagement')}</p>
                </NavLink>
              </div>
    )
  }


  return (
    <>
          {!userInfo?.is_corporate && !userInfo?.is_regional_corporate ? (
            !userInfo?.agency?.is_settings_complete ? null : (
              <div className='sidebar__links'>
                {(userInfo?.agency?.trial_status !== 'equipment' &&
                  userInfo?.agency?.trial_status !== 'inspection') ||
                userInfo?.is_global ? (
                  <NavLink
                    className={`sidebar__link ${location.pathname === '/dashboard' ? 'active' : ''}`}
                    to='/dashboard'
                  >
                    {userInfo?.is_corporate ||
                    userInfo?.is_regional_corporate ? (
                      <FboGraphicsIcon
                        color={
                          location.pathname === '/dashboard'
                            ? '#FFFFFF'
                            : '#AEB3B7'
                        }
                      />
                    ) : (
                      <Inspection
                        color={
                          location.pathname === '/dashboard'
                            ? '#FFFFFF'
                            : '#AEB3B7'
                        }
                      />
                    )}
                    <p className='sidebar__link-name'>
                      {userInfo?.is_corporate || userInfo?.is_regional_corporate
                        ? t('sidebar.fboDashboardBeta')
                        : t('sidebar.dashboard')}
                    </p>
                  </NavLink>
                ) : null}
                {userInfo?.permissions?.includes('inspection') &&
                  (userInfo?.agency?.trial_status === 'equipment' &&
                  !userInfo?.is_corporate &&
                  !userInfo?.is_global &&
                  !userInfo?.is_regional_corporate ? (
                    <p className={`sidebar__link inactive`}>
                      <Monitor
                        color={
                          location.pathname === '/inspections'
                            ? '#FFFFFF'
                            : '#AEB3B7'
                        }
                      />
                      <p className='sidebar__link-name'>{t('sidebar.inspections')}</p>
                    </p>
                  ) : (
                    <NavLink
                      className={`sidebar__link ${location.pathname === '/inspections' ? 'active' : ''}`}
                      to='/inspections'
                    >
                      <Monitor
                        color={
                          location.pathname === '/inspections'
                            ? '#FFFFFF'
                            : '#AEB3B7'
                        }
                      />
                      <p className='sidebar__link-name'>{t('sidebar.inspections')}</p>
                    </NavLink>
                  ))}
                {userInfo?.is_global && (
                  <>
                    <SideFBODropdown />
                    <SideCorporateDropdown />
                  </>
                )}

                {(userInfo?.is_global ||
                  userInfo?.is_admin ||
                  userInfo?.is_corporate ||
                  userInfo?.is_regional_corporate) &&
                userInfo?.agency?.trial_status === 'equipment' &&
                !userInfo?.is_corporate &&
                !userInfo?.is_global &&
                !userInfo?.is_regional_corporate ? (
                  <p className={`sidebar__link inactive`}>
                    <ToolsIcon
                      color={
                        location.pathname === '/tools' ? '#FFFFFF' : '#AEB3B7'
                      }
                    />
                    <p className='sidebar__link-name'>{t('sidebar.toolsManagement')}</p>
                  </p>
                ) : (
                  <NavLink
                    className={`sidebar__link ${location.pathname === '/tools' ? 'active' : ''}`}
                    to='/tools'
                  >
                    <ToolsIcon
                      color={
                        location.pathname === '/tools' ? '#FFFFFF' : '#AEB3B7'
                      }
                    />
                    <p className='sidebar__link-name'>{t('sidebar.toolsManagement')}</p>
                  </NavLink>
                )}
                {userInfo?.is_admin ? (
                  userInfo?.agency?.custom_inspections_enabled ? (
                    <>
                      <SideCustomInspectionsDropdown
                        showOld
                        custom_inspections_disabled={
                          userInfo?.agency?.custom_inspections_enabled === 0
                        }
                      />
                    </>
                  ) : (
                    <>
                      <SideCustomInspectionsDropdown
                        showOld
                        custom_inspections_disabled={
                          userInfo?.agency?.custom_inspections_enabled === 0
                        }
                      />
                    </>
                  )
                ) : userInfo?.is_global ? (
                  <>
                    <SideCustomInspectionsDropdown
                      showOld
                      custom_inspections_disabled={
                        userInfo?.agency?.custom_inspections_enabled === 0
                      }
                    />
                  </>
                ) : null}
                {userInfo?.permissions?.includes('facility') &&
                  (userInfo?.agency?.trial_status === 'equipment' ||
                  userInfo?.agency?.trial_status === 'inspection' ? (
                    <NavLink className={`sidebar__link`} to='/facility'>
                      <FacilityIcon
                        color={
                          location.pathname === '/facility'
                            ? '#FFFFFF'
                            : '#AEB3B7'
                        }
                      />
                      <p className='sidebar__link-name'>{t('sidebar.facility')}</p>
                    </NavLink>
                  ) : (
                    <NavLink className={`sidebar__link`} to='/facility'>
                      <FacilityIcon
                        color={
                          location.pathname === '/facility'
                            ? '#FFFFFF'
                            : '#AEB3B7'
                        }
                      />
                      <p className='sidebar__link-name'>{t('sidebar.facility')}</p>
                    </NavLink>
                  ))}
                {userInfo?.permissions?.includes('corrective_action') &&
                  (userInfo?.agency?.trial_status === 'equipment' &&
                  !userInfo?.is_corporate &&
                  !userInfo?.is_global &&
                  !userInfo?.is_regional_corporate ? (
                    <p className={`sidebar__link inactive`}>
                      <Corrective
                        color={
                          location.pathname === '/actions'
                            ? '#FFFFFF'
                            : '#AEB3B7'
                        }
                      />
                      <p className='sidebar__link-name'>{t('sidebar.correctiveActions')}</p>
                    </p>
                  ) : (
                    <Link
                      className={`sidebar__link ${location.pathname === '/actions' ? 'active' : ''}`}
                      to='/actions'
                    >
                      <Corrective
                        color={
                          location.pathname === '/actions'
                            ? '#FFFFFF'
                            : '#AEB3B7'
                        }
                      />
                      <p className='sidebar__link-name'>{t('sidebar.correctiveActions')}</p>
                    </Link>
                  ))}
                {userInfo?.permissions?.includes('log_sheet') &&
                  (userInfo?.agency?.trial_status === 'equipment' &&
                  !userInfo?.is_corporate &&
                  !userInfo?.is_global &&
                  !userInfo?.is_regional_corporate ? (
                    <p className={`sidebar__link inactive`}>
                      <Log
                        color={
                          location.pathname === '/log-sheets'
                            ? '#FFFFFF'
                            : '#AEB3B7'
                        }
                      />
                      <p className='sidebar__link-name'>{t('sidebar.logSheets')}</p>
                    </p>
                  ) : (
                    <Link
                      className={`sidebar__link ${location.pathname === '/log-sheets' ? 'active' : ''}`}
                      to='/log-sheets'
                    >
                      <Log
                        color={
                          location.pathname === '/log-sheets'
                            ? '#FFFFFF'
                            : '#AEB3B7'
                        }
                      />
                      <p className='sidebar__link-name'>{t('sidebar.logSheets')}</p>
                    </Link>
                  ))}
                {userInfo?.permissions?.includes('observation') &&
                  (userInfo?.agency?.trial_status === 'equipment' &&
                  !userInfo?.is_corporate &&
                  !userInfo?.is_global &&
                  !userInfo?.is_regional_corporate ? (
                    <p className={`sidebar__link inactive`}>
                      <Service
                        color={
                          location.pathname === '/observation'
                            ? '#FFFFFF'
                            : '#AEB3B7'
                        }
                      />
                      <p className='sidebar__link-name'>{t('sidebar.observation')}</p>
                    </p>
                  ) : (
                    <NavLink
                      className={`sidebar__link ${location.pathname === '/observation' ? 'active' : ''}`}
                      to='/observation'
                    >
                      <Service
                        color={
                          location.pathname === '/observation'
                            ? '#FFFFFF'
                            : '#AEB3B7'
                        }
                      />
                      <p className='sidebar__link-name'>{t('sidebar.observation')}</p>
                    </NavLink>
                  ))}

                {userInfo?.is_global && (
                  <NavLink className={`sidebar__link`} to='/equipment-type'>
                    <EquipmentType
                      color={
                        location.pathname === '/equipment-type'
                          ? '#FFFFFF'
                          : '#AEB3B7'
                      }
                    />
                    <p className='sidebar__link-name'>{t('sidebar.equipmentType')}</p>
                  </NavLink>
                )}
                {userInfo?.permissions?.includes('equipment_management') && (
                  <NavLink className={`sidebar__link`} to='/equipment?active=0'>
                    <Equipment
                      color={
                        location.pathname === '/equipment'
                          ? '#FFFFFF'
                          : '#AEB3B7'
                      }
                    />
                    <p className='sidebar__link-name'>{t('sidebar.equipmentManagement')}</p>
                  </NavLink>
                )}
                {userInfo?.permissions?.includes('user_management') && (
                  <Link
                    className={`sidebar__link ${location.pathname === '/management' ? 'active' : ''}`}
                    to='/management'
                  >
                    <Management
                      color={
                        location.pathname === '/management'
                          ? '#FFFFFF'
                          : '#AEB3B7'
                      }
                    />
                    <p className='sidebar__link-name'>{t('sidebar.userManagement')}</p>
                  </Link>
                )}
                {userInfo?.permissions?.includes('report') &&
                  (userInfo?.agency?.trial_status === 'equipment' &&
                  !userInfo?.is_corporate &&
                  !userInfo?.is_global &&
                  !userInfo?.is_regional_corporate ? (
                    <p className={`sidebar__link inactive`}>
                      <Report
                        color={
                          location.pathname === '/report'
                            ? '#FFFFFF'
                            : '#AEB3B7'
                        }
                      />
                      <p className='sidebar__link-name'>{t('sidebar.report')}</p>
                    </p>
                  ) : (
                    <Link
                      className={`sidebar__link ${location.pathname === '/report' ? 'active' : ''}`}
                      to='/report'
                    >
                      <Report
                        color={
                          location.pathname === '/report'
                            ? '#FFFFFF'
                            : '#AEB3B7'
                        }
                      />
                      <p className='sidebar__link-name'>{t('sidebar.report')}</p>
                    </Link>
                  ))}
                {userInfo?.permissions?.includes('fuel_receipt') &&
                  (userInfo?.agency?.trial_status === 'equipment' &&
                  !userInfo?.is_corporate &&
                  !userInfo?.is_global &&
                  !userInfo?.is_regional_corporate ? (
                    <p className={`sidebar__link inactive`}>
                      <Fuel
                        color={
                          location.pathname === '/receipt-form'
                            ? '#FFFFFF'
                            : '#AEB3B7'
                        }
                      />
                      <p className='sidebar__link-name'>{t('sidebar.fuelReceiptForm')}</p>
                    </p>
                  ) : (
                    <Link
                      className={`sidebar__link ${location.pathname === '/receipt-form' ? 'active' : ''}`}
                      to='/receipt-form'
                    >
                      <Fuel
                        color={
                          location.pathname === '/receipt-form'
                            ? '#FFFFFF'
                            : '#AEB3B7'
                        }
                      />
                      <p className='sidebar__link-name'>{t('sidebar.fuelReceiptForm')}</p>
                    </Link>
                  ))}
                {userInfo?.is_global && (
                  <>
                    <NavLink
                      className={`sidebar__link ${location.pathname === '/settings' ? 'active' : ''}`}
                      to='/settings'
                    >
                      <Settings
                        color={
                          location.pathname === '/settings'
                            ? '#FFFFFF'
                            : '#AEB3B7'
                        }
                      />
                      <p className='sidebar__link-name'>{t('sidebar.settings')}</p>
                    </NavLink>
                    <NavLink
                      className={`sidebar__link ${location.pathname === routes.private.historyLogs ? 'active' : ''}`}
                      to={routes.private.historyLogs}
                    >
                      <NoteIcon
                        color={
                          location.pathname === routes.private.historyLogs
                            ? '#FFFFFF'
                            : '#AEB3B7'
                        }
                      />
                      <p className='sidebar__link-name'>{t('sidebar.historyLogs')}</p>
                    </NavLink>
                    <NavLink
                      className={`sidebar__link ${location.pathname === routes.private.reportsHealthyList ? 'active' : ''}`}
                      to={routes.private.reportsHealthyList}
                    >
                      <Report
                        color={
                          location.pathname === routes.private.reportsHealthyList
                            ? '#FFFFFF'
                            : '#AEB3B7'
                        }
                      />
                      <p className='sidebar__link-name'>{t('sidebar.reportsChecks')}</p>
                    </NavLink>
                    <NavLink
                    className={`sidebar__link ${location.pathname === routes.private.languageManagement ? 'active' : ''}`}
                    to={routes.private.languageManagement}
                  >
                    <LanguageIcon
                      color={
                        location.pathname === routes.private.languageManagement ? '#FFFFFF' : '#AEB3B7'
                      }
                    />
                    <p className='sidebar__link-name'>{t('sidebar.languageManagement')}</p>
                  </NavLink>
                  </>
                )}
              </div>
            )
          ) : userInfo?.corporate?.agencies?.length > 0 ||
            userInfo?.is_regional_corporate ? (
            <div className='sidebar__links'>
              <NavLink
                className={`sidebar__link ${location.pathname === '/dashboard' ? 'active' : ''}`}
                to='/dashboard'
              >
                {userInfo?.is_corporate ? (
                  <FboGraphicsIcon
                    color={
                      location.pathname === '/dashboard' ? '#FFFFFF' : '#AEB3B7'
                    }
                  />
                ) : (
                  <Inspection
                    color={
                      location.pathname === '/dashboard' ? '#FFFFFF' : '#AEB3B7'
                    }
                  />
                )}
                <p className='sidebar__link-name'>
                  {userInfo?.is_corporate ? t('sidebar.fboDashboard') : t('sidebar.dashboard')}
                </p>
              </NavLink>
              {userInfo?.permissions?.includes('inspection') &&
                (userInfo?.agency?.trial_status === 'equipment' &&
                !userInfo?.is_corporate &&
                !userInfo?.is_global &&
                !userInfo?.is_regional_corporate ? (
                  <p className={`sidebar__link inactive`}>
                    <Monitor
                      color={
                        location.pathname === '/inspections'
                          ? '#FFFFFF'
                          : '#AEB3B7'
                      }
                    />
                    <p className='sidebar__link-name'>{t('sidebar.inspections')}</p>
                  </p>
                ) : (
                  <NavLink
                    className={`sidebar__link ${location.pathname === '/inspections' ? 'active' : ''}`}
                    to='/inspections'
                  >
                    <Monitor
                      color={
                        location.pathname === '/inspections'
                          ? '#FFFFFF'
                          : '#AEB3B7'
                      }
                    />
                    <p className='sidebar__link-name'>{t('sidebar.inspections')}</p>
                  </NavLink>
                ))}
              {userInfo?.is_global && <SideFBODropdown />}

              {/*{*/}
              {/*  userInfo?.is_global &&*/}
              {/*  <NavLink className={`sidebar__link ${location.pathname === '/fbo/all' ? 'active' : ''}`} to="/fbo/all">*/}
              {/*    <AgancyIcon color={location.pathname === '/fbo/all' ? '#FFFFFF' : '#AEB3B7' } />*/}
              {/*    <p className="sidebar__link-name">FBO</p>*/}
              {/*  </NavLink>*/}
              {/*}*/}

              {userInfo?.is_global && (
                <NavLink
                  className={`sidebar__link ${location.pathname === '/corporate' ? 'active' : ''}`}
                  to='/corporate'
                >
                  <CorporateIcon
                    color={
                      location.pathname === '/corporate' ? '#FFFFFF' : '#AEB3B7'
                    }
                  />
                  <p className='sidebar__link-name'>{t('sidebar.corporate')}</p>
                </NavLink>
              )}

              {userInfo?.is_global && (
                <NavLink
                  className={`sidebar__link ${location.pathname === '/orders' ? 'active' : ''}`}
                  to='/orders'
                >
                  <svg
                    style={{marginLeft: '-20px'}}
                    width='48'
                    height='48'
                    viewBox='0 0 32 48'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      fillRule='evenodd'
                      clipRule='evenodd'
                      d='M24 32.8C28.8601 32.8 32.8 28.8601 32.8 24C32.8 19.1399 28.8601 15.2 24 15.2C19.1399 15.2 15.2 19.1399 15.2 24C15.2 28.8601 19.1399 32.8 24 32.8ZM24 35C30.0751 35 35 30.0751 35 24C35 17.9249 30.0751 13 24 13C17.9249 13 13 17.9249 13 24C13 30.0751 17.9249 35 24 35Z'
                      fill={
                        location.pathname === '/orders' ? '#FFFFFF' : '#AEB3B7'
                      }
                    />
                    <path
                      d='M22.8996 18.5004C22.8996 17.8929 23.3921 17.4004 23.9996 17.4004C24.6071 17.4004 25.0996 17.8929 25.0996 18.5004C26.9221 18.5004 28.3996 19.9779 28.3996 21.8004C28.3996 22.4079 27.9071 22.9004 27.2996 22.9004C26.6921 22.9004 26.1996 22.4079 26.1996 21.8004C26.1996 21.1929 25.7071 20.7004 25.0996 20.7004H22.6174C22.1657 20.7004 21.7996 21.0665 21.7996 21.5181C21.7996 21.8701 22.0248 22.1826 22.3588 22.2939L26.3361 23.6197C27.5684 24.0305 28.3996 25.1837 28.3996 26.4826C28.3996 28.1493 27.0485 29.5004 25.3819 29.5004H25.0996C25.0996 30.1079 24.6071 30.6004 23.9996 30.6004C23.3921 30.6004 22.8996 30.1079 22.8996 29.5004C21.0771 29.5004 19.5996 28.0229 19.5996 26.2004C19.5996 25.5929 20.0921 25.1004 20.6996 25.1004C21.3071 25.1004 21.7996 25.5929 21.7996 26.2004C21.7996 26.8079 22.2921 27.3004 22.8996 27.3004H25.3819C25.8335 27.3004 26.1996 26.9343 26.1996 26.4826C26.1996 26.1306 25.9744 25.8181 25.6404 25.7068L21.6631 24.381C20.4308 23.9703 19.5996 22.8171 19.5996 21.5181C19.5996 19.8515 20.9507 18.5004 22.6174 18.5004H22.8996Z'
                      fill={
                        location.pathname === '/orders' ? '#FFFFFF' : '#AEB3B7'
                      }
                    />
                  </svg>
                  <p className='sidebar__link-name orders'>
                    {t('sidebar.orders')}
                    {userInfo?.orders && (
                      <span
                        style={{backgroundColor: userInfo?.orders?.order_color}}
                      >
                        {userInfo?.orders?.count}
                      </span>
                    )}
                  </p>
                </NavLink>
              )}

              {(userInfo?.is_corporate || userInfo?.is_regional_corporate) && (
                <>
                  <NavLink
                    className={`sidebar__link ${location.pathname === '/tools' ? 'active' : ''}`}
                    to='/tools'
                  >
                    <ToolsIcon
                      color={
                        location.pathname === '/tools' ? '#FFFFFF' : '#AEB3B7'
                      }
                    />
                    <p className='sidebar__link-name'>{t('sidebar.toolsManagement')}</p>
                  </NavLink>
                </>
              )}
              <SideCustomInspectionsDropdown
                custom_inspections_disabled={
                  userInfo?.agency?.custom_inspections_enabled === 0
                }
                showOld
              />
              {userInfo?.permissions?.includes('facility') &&
                (userInfo?.agency?.trial_status === 'equipment' ||
                userInfo?.agency?.trial_status === 'inspection' ? (
                  <NavLink className={`sidebar__link`} to='/facility'>
                    <FacilityIcon
                      color={
                        location.pathname === '/facility'
                          ? '#FFFFFF'
                          : '#AEB3B7'
                      }
                    />
                    <p className='sidebar__link-name'>{t('sidebar.facility')}</p>
                  </NavLink>
                ) : (
                  <NavLink className={`sidebar__link`} to='/facility'>
                    <FacilityIcon
                      color={
                        location.pathname === '/facility'
                          ? '#FFFFFF'
                          : '#AEB3B7'
                      }
                    />
                    <p className='sidebar__link-name'>{t('sidebar.facility')}</p>
                  </NavLink>
                ))}
              {userInfo?.permissions?.includes('corrective_action') &&
                (userInfo?.agency?.trial_status === 'equipment' &&
                !userInfo?.is_corporate &&
                !userInfo?.is_global &&
                !userInfo?.is_regional_corporate ? (
                  <p className={`sidebar__link inactive`}>
                    <Corrective
                      color={
                        location.pathname === '/actions' ? '#FFFFFF' : '#AEB3B7'
                      }
                    />
                    <p className='sidebar__link-name'>{t('sidebar.correctiveActions')}</p>
                  </p>
                ) : (
                  <Link
                    className={`sidebar__link ${location.pathname === '/actions' ? 'active' : ''}`}
                    to='/actions'
                  >
                    <Corrective
                      color={
                        location.pathname === '/actions' ? '#FFFFFF' : '#AEB3B7'
                      }
                    />
                    <p className='sidebar__link-name'>{t('sidebar.correctiveActions')}</p>
                  </Link>
                ))}
              {userInfo?.permissions?.includes('log_sheet') &&
                (userInfo?.agency?.trial_status === 'equipment' &&
                !userInfo?.is_corporate &&
                !userInfo?.is_global &&
                !userInfo?.is_regional_corporate ? (
                  <p className={`sidebar__link inactive`}>
                    <Log
                      color={
                        location.pathname === '/log-sheets'
                          ? '#FFFFFF'
                          : '#AEB3B7'
                      }
                    />
                    <p className='sidebar__link-name'>{t('sidebar.logSheets')}</p>
                  </p>
                ) : (
                  <Link
                    className={`sidebar__link ${location.pathname === '/log-sheets' ? 'active' : ''}`}
                    to='/log-sheets'
                  >
                    <Log
                      color={
                        location.pathname === '/log-sheets'
                          ? '#FFFFFF'
                          : '#AEB3B7'
                      }
                    />
                    <p className='sidebar__link-name'>{t('sidebar.logSheets')}</p>
                  </Link>
                ))}
              {userInfo?.permissions?.includes('observation') &&
                (userInfo?.agency?.trial_status === 'equipment' &&
                !userInfo?.is_corporate &&
                !userInfo?.is_global &&
                !userInfo?.is_regional_corporate ? (
                  <p className={`sidebar__link inactive`}>
                    <Service
                      color={
                        location.pathname === '/observation'
                          ? '#FFFFFF'
                          : '#AEB3B7'
                      }
                    />
                    <p className='sidebar__link-name'>{t('sidebar.observation')}</p>
                  </p>
                ) : (
                  <NavLink
                    className={`sidebar__link ${location.pathname === '/observation' ? 'active' : ''}`}
                    to='/observation'
                  >
                    <Service
                      color={
                        location.pathname === '/observation'
                          ? '#FFFFFF'
                          : '#AEB3B7'
                      }
                    />
                    <p className='sidebar__link-name'>{t('sidebar.observation')}</p>
                  </NavLink>
                ))}
              {userInfo?.permissions?.includes('equipment_management') && (
                <NavLink className={`sidebar__link`} to='/equipment?active=0'>
                  <Equipment
                    color={
                      location.pathname === '/equipment' ? '#FFFFFF' : '#AEB3B7'
                    }
                  />
                  <p className='sidebar__link-name'>{t('sidebar.equipmentManagement')}</p>
                </NavLink>
              )}
              {userInfo?.permissions?.includes('user_management') &&
              !userInfo?.is_corporate &&
              !userInfo?.is_regional_corporate ? (
                <Link
                  className={`sidebar__link ${location.pathname === '/management' ? 'active' : ''}`}
                  to='/management'
                >
                  <Management
                    color={
                      location.pathname === '/management'
                        ? '#FFFFFF'
                        : '#AEB3B7'
                    }
                  />
                  <p className='sidebar__link-name'>{t('sidebar.userManagement')}</p>
                </Link>
              ) : null}
              {userInfo?.permissions?.includes('report') &&
                (userInfo?.agency?.trial_status === 'equipment' &&
                !userInfo?.is_corporate &&
                !userInfo?.is_global &&
                !userInfo?.is_regional_corporate ? (
                  <p className={`sidebar__link inactive`}>
                    <Report
                      color={
                        location.pathname === '/report' ? '#FFFFFF' : '#AEB3B7'
                      }
                    />
                    <p className='sidebar__link-name'>{t('sidebar.report')}</p>
                  </p>
                ) : (
                  <Link
                    className={`sidebar__link ${location.pathname === '/report' ? 'active' : ''}`}
                    to='/report'
                  >
                    <Report
                      color={
                        location.pathname === '/report' ? '#FFFFFF' : '#AEB3B7'
                      }
                    />
                    <p className='sidebar__link-name'>{t('sidebar.report')}</p>
                  </Link>
                ))}

              {userInfo?.permissions?.includes('fuel_receipt') &&
                (userInfo?.agency?.trial_status === 'equipment' &&
                !userInfo?.is_corporate &&
                !userInfo?.is_global &&
                !userInfo?.is_regional_corporate ? (
                  <p className={`sidebar__link inactive`}>
                    <Fuel
                      color={
                        location.pathname === '/receipt-form'
                          ? '#FFFFFF'
                          : '#AEB3B7'
                      }
                    />
                    <p className='sidebar__link-name'>{t('sidebar.fuelReceiptForm')}</p>
                  </p>
                ) : (
                  <Link
                    className={`sidebar__link ${location.pathname === '/receipt-form' ? 'active' : ''}`}
                    to='/receipt-form'
                  >
                    <Fuel
                      color={
                        location.pathname === '/receipt-form'
                          ? '#FFFFFF'
                          : '#AEB3B7'
                      }
                    />
                    <p className='sidebar__link-name'>{t('sidebar.fuelReceiptForm')}</p>
                  </Link>
                ))}
              {userInfo?.is_global && (
                <NavLink
                  className={`sidebar__link ${location.pathname === '/settings' ? 'active' : ''}`}
                  to='/settings'
                >
                  <Settings
                    color={
                      location.pathname === '/settings' ? '#FFFFFF' : '#AEB3B7'
                    }
                  />
                  <p className='sidebar__link-name'>{t('sidebar.settings')}</p>
                </NavLink>
              )}
            </div>
          ) : null}
    </>
  )
}